'use client';

import React from 'react';
import { TIERS, TierName } from '@/lib/tierConfig';
import { Check } from 'lucide-react';

interface TierAvatarProps {
  level: number;
  tier: TierName;
  isHired?: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  isPulsing?: boolean;
}

const sizeMap = {
  sm: { outer: 'w-8 h-8', text: 'text-xs', icon: 14 },
  md: { outer: 'w-10 h-10', text: 'text-sm', icon: 16 },
  lg: { outer: 'w-14 h-14', text: 'text-lg', icon: 22 },
  xl: { outer: 'w-20 h-20', text: 'text-2xl', icon: 28 },
};

export default function TierAvatar({
  level,
  tier,
  isHired = false,
  size = 'md',
  isPulsing = false,
}: TierAvatarProps) {
  const config = TIERS.find((t) => t.name === tier) ?? TIERS[0];
  const s = sizeMap[size];

  return (
    <div
      className={`${s.outer} rounded-full flex items-center justify-center font-bold select-none flex-shrink-0`}
      style={{
        backgroundColor: config.fill,
        border: `2px solid ${config.border}`,
        color: config.text,
      }}
    >
      {isHired ? (
        <Check size={s.icon} strokeWidth={3} style={{ color: config.text }} />
      ) : (
        <span className={`${s.text} font-bold`} style={{ color: config.text }}>
          {level}
        </span>
      )}
    </div>
  );
}